export default __webpack_public_path__ + "static/media/textInput.96d4b1bf.gif";